export const eulaConfig = {
    // list of supported EULA versions
    // IMPORTANT: Has to be kept in sync with accounts-service:
    //  application.yaml -> application.eula.known-versions
    supportedVersions: ['1.0.1', '1.0.2', '1.0.4'],
    // this value is also hard coded in asset-connector-web and must be kept in sync
    version: '1.0.4',
    url: '/eula/EULA.html',
    digitalServicesCancellationDate: Date.parse('2025-09-12T12:00:00Z'),
};
